import { $authHost } from './index'
import { httpPoint } from '../utils/const'



export const getAll = async (page, limit) => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.post(httpPoint.order + 'getAll', { page, limit })
        return data
    }
}